import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {catchError, takeUntil} from 'rxjs/operators';

import {ErrorStateService} from '../error-state/error-state.service';
import {ErrorHandler} from '../../strategies/error-states-strategy';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  private pendingInterceptedHttp$: Subject<void> = new Subject();

  constructor(
    private router: Router,
    private errorStateService: ErrorStateService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {

    return next.handle(req).pipe(
      takeUntil(this.pendingInterceptedHttp$),
      catchError((event) => {
        const handler = new ErrorHandler(this.router, this.errorStateService);
        return handler.handleErrorStates(event, this.pendingInterceptedHttp$);
      })
    );
  }
}
